var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-card',{staticClass:"lp-app-card",class:{ 'lp-app-card--active': hover },attrs:{"href":_vm.href,"tag":"a","target":_vm.target}},[_c('v-img',{attrs:{"src":_vm.imageSrc}}),_c('v-card-title',[_c('span',{staticClass:"lp-app-card__title kg-l-light-24"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)}}])})}
var staticRenderFns = []

export { render, staticRenderFns }